import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { AddUserNoteDialogController } from 'dialog/add-user-note-dialog/add-user-note-dialog.controller';
import { AddUserNoteDialogData } from 'dialog/add-user-note-dialog/add-user-note-dialog.data';

@Component({
	selector: 'spr-add-user-note-dialog',
	templateUrl: './add-user-note-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [AddUserNoteDialogController],
})
export class AddUserNoteDialogComponent {
	constructor(
		public controller: AddUserNoteDialogController,
		private _config: DynamicDialogConfig,
		private _dialogRef: DynamicDialogRef
	) {}

	public onSubmitAddUserNoteClick() {
		const data: AddUserNoteDialogData = this._config.data;

		this.controller.saveNote(data.coacheeId).then(() => this._dialogRef.close());
	}
}
